import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next/hooks';

import Button from '../../components/Button/Button';
import GroupJoinControll from '../../components/GroupTalk/GroupInfo/GroupJoinControll';
import GroupTalkTextInput from '../../components/GroupTalk/GroupTextList/GroupTalkTextInput';
import GroupTalkTextListInfo from '../../components/GroupTalk/GroupInfo/GroupTalkTextListInfo';
import GroupTalkTextList from '../../components/GroupTalk/GroupTextList/GroupTalkTextList';

import { 
  // storeDraftInput, 
  getDraftInput, 
  // deleteDraftInput 
} from '../../util/style';
// import { updateLsNameDataList } from '../../util/user-name-data/user-name-data-util';

import { useStore } from '../../hook-store/store';


import '../VideoTextTalk/VideoTextTalk.css'
import './GroupTalk.css';



const GroupTalkText = (props) => {
  const {
    userId,
    showGroupTalkText,
    joinGroupHandler,
    deleteGroupMemberHandler,
    deleteMemberResult,
    setShowAuthModal,
    groupUserInfo,
    editFavoriteGroupsHandler,
    editFavoriteGroupsResult,
    showGroupTextInputElement,
    groupTextReactions,
    createGroupTextReactionHandler,
    getGroupInfoHandler,
    groupTextDeleteHandler,
    getInputHandler,
    textInputHandlerEmoji,
    groupTextInput,
    groupTextPostHandler,
    showGroupTextInputElementHandler,
    isTextPosting,
    showGroupTalkTextHandler,
    leaveGroupHandler,
    isLoading,
  } = props;


  // const lsToken = localStorage.getItem('token');

  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  const { 
    selectedGroupData,
    isGroupMember,
  } = store.groupStore;
  // const { 
  //   userData, 
  // } = store;
  const {
    isAuth
  } = store.uiStore;

  // const userId = userData?.userId ? userData.userId : groupNoAuthUserId;
  // const userName = '';
  // console.log('joinedGroupData in GroupTalk.js', joinedGroupData);


  let backToListButton;
  if (showGroupTalkText && !isGroupMember) {
    backToListButton = (
      <div className="groupTalk__BackToListButton groupTalk__buttonSmall">
        <Button mode="flat" type="submit"
          className="groupTalk__BackToListButton"
          onClick={() => {
            showGroupTalkTextHandler();
            leaveGroupHandler();
            // socketDisconnectHandler();
          }}
        >
          {t('groupTalk.text11', 'Back to list')}
        </Button>
      </div>
    );
  }
  if (showGroupTalkText && isGroupMember) {
    backToListButton = (
      <div className="groupTalk__BackToListButton groupTalk__buttonSmall">
        <Button mode="flat" type="submit"
          onClick={() => {
            showGroupTalkTextHandler();
            leaveGroupHandler();
            // socketDisconnectHandler();

            //// notify draft save and delte notification
            if (getDraftInput('group', selectedGroupData?.groupRoomId)) {
              // dispatch('SHOW_NOTIFICATION', {
              //   status: 'pending',
              //   title: '',
              //   message: 'Draft saved in device',
              // });

              // setTimeout(() => {
              //   dispatch('CLEAR_NOTIFICATION');
              // }, 1000*3);
            }
          }}
        >
          {t('groupTalk.text11', 'Back to list')}
        </Button>
      </div>
    )
  }

  // console.log('showGroupTalkText && selectedGroupData', showGroupTalkText, selectedGroupData, socketState, userSocketId)

  let groupTextBody;

  if (showGroupTalkText && selectedGroupData) {
    groupTextBody = (
      <div>

        {backToListButton}

        <GroupJoinControll 
          userId={userId}
          // usersData={usersData}
          joinGroupId={selectedGroupData._id}
          groupTalkId={selectedGroupData._id}
          groupInfo={selectedGroupData}
          // groupAllMemberList={selectedGroupData.allMemberUserIds}
          allMemberUserIds={selectedGroupData.allMemberUserIds}
          isAuth={isAuth}
          joinGroupHandler={joinGroupHandler}
          deleteGroupMemberHandler={deleteGroupMemberHandler}
          deleteMemberResult={deleteMemberResult}
          isGroupMember={isGroupMember}
          // getIsMemberHandler={getIsMemberHandler}
          setShowAuthModal={setShowAuthModal}
          isLoading={isLoading}
        />

        {isAuth &&
          <GroupTalkTextListInfo
            userId={userId}
            groupInfo={selectedGroupData}
            // groupAllMemberList={selectedGroupData.allMemberUserIds}
            allMemberUserIds={selectedGroupData.allMemberUserIds}
            // getIsMemberHandler={getIsMemberHandler}
            groupUserInfo={groupUserInfo}
            editFavoriteGroupsHandler={editFavoriteGroupsHandler}
            editFavoriteGroupsResult={editFavoriteGroupsResult}
            deleteGroupMemberHandler={deleteGroupMemberHandler}
            deleteMemberResult={deleteMemberResult}
            joinGroupId={selectedGroupData._id}
            joinGroupHandler={joinGroupHandler}
            isLoading={isLoading}
          />
        }

        <GroupTalkTextList
          userId={userId}
          allMemberUserIds={selectedGroupData.allMemberUserIds}
          showGroupTextInputElement={showGroupTextInputElement}
          groupTextReactions={groupTextReactions}
          createGroupTextReactionHandler={createGroupTextReactionHandler}
          getGroupInfoHandler={getGroupInfoHandler}
          groupTalkId={selectedGroupData._id}
          groupTextDeleteHandler={groupTextDeleteHandler}
          groupTextPostHandler={groupTextPostHandler}
          isTextPosting={isTextPosting}
          isLoading={isLoading}
        />

        {showGroupTextInputElement && (
          <div className="groupTalk__textInputContainer">
            <GroupTalkTextInput
              getInputHandler={getInputHandler}
              textInputHandlerEmoji={textInputHandlerEmoji}
              groupTextInput={groupTextInput}
              groupTextPostHandler={groupTextPostHandler}
              joinGroupId={selectedGroupData._id}
              showGroupTextInputElement={showGroupTextInputElement}
              showGroupTextInputElementHandler={showGroupTextInputElementHandler}
              isTextPosting={isTextPosting}
              isAuth={isAuth}
              isGroupMember={isGroupMember}
              setShowAuthModal={setShowAuthModal}
              isLoading={isLoading}
            />
          </div>
        )}

        {showGroupTextInputElement && (
          <div
            className="groupTalk__showInputButton"
            // style={{position: "fixed", bottom:"75px", right:"1px"}}
            onClick={() => {
              showGroupTextInputElementHandler();
              // textPostHandler(textInput);
            }}
          >
            <Button
              mode="raised" type="submit"
              disabled={groupTextInput}
              onClick={() => {
                showGroupTextInputElementHandler();
                // textPostHandler(textInput);
              }}
            >
              {t('groupTalk.text36', 'hide')}
            </Button>
          </div>
        )}
        {!showGroupTextInputElement && (
          <div className="groupTalk__showInputButton"
          // style={{fontSize:"0.75rem", width:"40%", bottom:"1px"}}
          >
            <Button
              mode="raised" type="submit"
              // disabled={!groupTextInput}
              onClick={() => {
                showGroupTextInputElementHandler();
                // textPostHandler(textInput);
              }}
            >
              {t('groupTalk.text37', 'write text')}
              </Button>
          </div>
        )}
      </div>
    );
  }


  return (
    <Fragment>
      <div>
        {groupTextBody}
      </div>
    </Fragment>
  );
};

export default GroupTalkText;